export const ADD_ORDER_HISTORY = 'ADD_ORDER_HISTORY'
export const SET_ORDER_HISTORY = 'SET_ORDER_HISTORY'
export const REMOVE_ORDER_HISTORY = 'REMOVE_ORDER_HISTORY'
